import css from 'styled-jsx/css'
import { colors, fontSizes } from 'theme'

export default css`
  .breadcrumb {
    display: flex;
    list-style-type: none;
    color: ${colors.text};
    padding-left: 1rem;
  }
  .breadcrumb-item {
    margin-right: 0.5rem;
    display: flex;
    align-items: center;
  }
  .breadcrumb-name {
    color: ${colors.text};
    font-size: ${fontSizes.small};
  }
  .breadcrumb-name:hover {
    text-decoration: underline;
  }
  .breadcrumb-name.deactivated {
    pointer-events: none;
    color: ${colors.alpha(colors.text, 0.5)};
  }
`